import React, { ReactElement, useEffect, useMemo, useState } from "react";
import path from "path";
import { CodeChallengeLoading } from "./CodeChallengeLoading";
import { EditorData } from "./CodeChallengeEditor";
import { withPrefix } from "gatsby";

type LoadEditorDataProps = {
  courseId?: string;
  taskId: string;
  children: (data: EditorData, functionUrl: string) => ReactElement;
};

export function LoadEditorData({
  courseId = "",
  taskId,
  children,
}: LoadEditorDataProps) {
  const [data, setData] = useState<EditorData>();
  const functionUrl = useMemo(
    () => path.join(withPrefix("/.netlify/functions/cc"), courseId, taskId),
    [courseId, taskId]
  );

  useEffect(() => {
    fetch(functionUrl)
      .then((response) => response.json())
      .then(setData);
  }, [functionUrl]);

  if (!data) {
    return <CodeChallengeLoading>Loading initial values</CodeChallengeLoading>;
  }

  return children(data, functionUrl);
}
